module.exports = __webpack_public_path__ + "static/media/carrinho_vazio.8cc60394.svg";